import { eUserType } from '../../ui-toolkit/orders/interfaces/eUserType';

export interface IGetUser {
  userId: string;
  userType: TUsertype;
}

export interface IUserData {
  id: string;
  name?: string;
  email: string;
  userType: TUsertype;
}

export type TUsertype = 'ADMIN' | 'VENDOR_USER' | 'CLIENT_USER' | 'LENDER_USER';

export const convertEUserTypeToTUsertype = (userType: eUserType): TUsertype => {
  switch (userType) {
    case eUserType.Admin:
      return 'ADMIN';
    case eUserType.VendorUser:
      return 'VENDOR_USER';
    case eUserType.ClientUser:
      return 'CLIENT_USER';
    case eUserType.LenderUser:
      return 'LENDER_USER';
    default:
      return 'ADMIN';
  }
};
